/**
* Controller for the standalone pitch form page
* @author Brendan Magee
*/

function StandalonePitchFormController(
  $log,
  $q,
  $translate,
  $window,
  $transition$,
  platformService,
  siteService,
  Story
) {
  const stateParams = $transition$.params();

  const decodeStoryId = storyId => decodeURIComponent(decodeURIComponent(storyId));
  const storyId = decodeStoryId(stateParams.storyID);

  $q.all([
    platformService.getAll(),
    siteService.getWebsites(),
    Story.get(storyId)
  ])
    .then((data) => {
      const [platforms, sites, story] = data;
      this.platforms = platforms;
      const platformSites = sites
        .filter(site =>
          (platforms.findIndex(plat => plat.website === site._id) > -1));

      const availableTypes = [
        'platforms',
        'publications'
      ];

      this.storyId = story.id;
      this.type = availableTypes.indexOf(stateParams.type) > -1 ? stateParams.type : null;
      this.sites = this.type === 'publications' ? sites : platformSites;

      if (!this.type) {
        this.errorMessage = $translate.instant('MISSING_PITCH_TYPE_ERROR', { type: stateParams.type });
      }

      this.pitches = {
        platforms: story.pitches,
        publications: story.publicationPitches
      };

      this.excludedDestinations = this.type === 'platforms' ? this.getExcludedPlatforms() : this.getExcludedPublications();
    }, (response) => {
      this.storyId = null;
      const error = $translate.instant('ERROR');

      if (
        response
        && response.data
        && (response.data.error || response.data.errors)
      ) {
        this.errorMessage = response.data.error === 'The requested story was not found'
          ? $translate.instant('INCORRECT_STORY_ID_ERROR', { id: storyId })
          : $translate.instant('ERROR_GETTING_REQUIRED_RESOURCE');
      } else {
        this.errorMessage = error;
      }
    });

  this.getExcludedPlatforms = () => {
    if (!this.pitches.platforms) {
      return [];
    }

    return this.pitches.platforms
      .reduce((acc, pitch) => {
        if (pitch.currentStatus !== 'withdrawn') {
          acc.push({
            path: pitch.planPath,
            website: pitch.website
          });
        }

        return acc;
      }, []);
  };

  this.getExcludedPublications = () => {
    if (!this.pitches.publications) {
      return [];
    }

    return this.pitches.publications
      .map(pitch => pitch.publicationId);
  };

  this.success = (pitchData) => {
    $log.log('Pitches created:', pitchData);
    let newPitches;

    if (this.type === 'platforms') {
      newPitches = pitchData.data.map(pitch => ({ path: pitch.planPath, website: pitch.website }));
    } else {
      newPitches = pitchData.data.map(pitch => pitch.publicationId);
    }

    this.excludedDestinations = this.excludedDestinations.concat(newPitches);

    if (pitchData.postMessage) {
      const postMsgData = {
        pitchData: pitchData.data,
        eventType: `wsk.${this.type}.pitch.create`
      };

      $window.parent.postMessage(postMsgData, $window.origin);
    }
  };

  this.closeModal = () => {
    const postMsgData = {
      eventType: 'cancel'
    };

    $window.parent.postMessage(postMsgData, $window.origin);
  };
}

const ctrlArray = [
  '$log',
  '$q',
  '$translate',
  '$window',
  '$transition$',
  'platformService',
  'siteService',
  'Story',
  StandalonePitchFormController
];

export default function (ngModule) {
  ngModule.controller('StandalonePitchFormController', ctrlArray);
}
